import { composeIO } from 'react-compose-io'
import { modalAdicionarObservacaoIO } from './ModalAdicionarObservacao.IO'
import ModalAdicionarObservacaoView from './ModalAdicionarObservacao.View'

export const ModalAdicionarObservacao = composeIO(ModalAdicionarObservacaoView, modalAdicionarObservacaoIO)
